import * as React from "react";
function SvgDashboardCustom(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <g
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      >
        <path d="M11 21h10M16 10v11M19 14v7M13 17v4M31 12V6a1 1 0 00-1-1h-6M24 27h6a1 1 0 001-1v-6M1 20v6a1 1 0 001 1h6M8 5H2a1 1 0 00-1 1v6" />
      </g>
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgDashboardCustom);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
